import { render, staticRenderFns } from "./wxdialecticalchart.vue?vue&type=template&id=d69c3da6&scoped=true&"
import script from "./wxdialecticalchart.vue?vue&type=script&lang=js&"
export * from "./wxdialecticalchart.vue?vue&type=script&lang=js&"
import style0 from "./wxdialecticalchart.vue?vue&type=style&index=0&id=d69c3da6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d69c3da6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d69c3da6')) {
      api.createRecord('d69c3da6', component.options)
    } else {
      api.reload('d69c3da6', component.options)
    }
    module.hot.accept("./wxdialecticalchart.vue?vue&type=template&id=d69c3da6&scoped=true&", function () {
      api.rerender('d69c3da6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wxreport/components/wxdialecticalchart.vue"
export default component.exports